import React, { useState } from 'react';
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    ModalCloseButton,
    Button,
    FormControl,
    FormLabel,
    Input,
    useToast,
    VStack
} from '@chakra-ui/react';
import axios from 'axios';
import { api_url } from '../../url';

const AdminChangePasswordModal = ({ isOpen, onClose, hasPassword }) => {
    const [currentPassword, setCurrentPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const toast = useToast();

    const handleSubmit = async () => {
        if (hasPassword && !currentPassword) {
            toast({ title: 'Current password is required', status: 'error', duration: 3000 });
            return;
        }
        if (newPassword !== confirmPassword) {
            toast({ title: 'Passwords do not match', status: 'error', duration: 3000 });
            return;
        }
        if (newPassword.length < 6) {
            toast({ title: 'Password must be at least 6 characters', status: 'error', duration: 3000 });
            return;
        }

        setLoading(true);
        try {
            const token = localStorage.getItem('token');
            const response = await axios.put(`${api_url}/users/change-password`, {
                currentPassword,
                newPassword
            }, {
                headers: { Authorization: `Bearer ${token}` }
            });

            if (response.data.success) {
                toast({ title: 'Password updated successfully', status: 'success', duration: 3000 });
                setCurrentPassword('');
                setNewPassword('');
                setConfirmPassword('');
                onClose();
            } else {
                throw new Error(response.data.message || 'Update failed');
            }
        } catch (error) {
            toast({ 
                title: 'Failed to update password', 
                description: error.response?.data?.message || error.message || 'Something went wrong', 
                status: 'error',
                duration: 3000
            });
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal isOpen={isOpen} onClose={onClose} isCentered>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>Update Password</ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                    <VStack spacing={4}>
                        {hasPassword && (
                            <FormControl isRequired>
                                <FormLabel>Current Password</FormLabel>
                                <Input 
                                    type="password" 
                                    value={currentPassword} 
                                    onChange={(e) => setCurrentPassword(e.target.value)}
                                    placeholder="Enter current password"
                                />
                            </FormControl>
                        )}
                        <FormControl isRequired>
                            <FormLabel>New Password</FormLabel>
                            <Input 
                                type="password" 
                                value={newPassword} 
                                onChange={(e) => setNewPassword(e.target.value)}
                                placeholder="Enter new password"
                            />
                        </FormControl>
                        <FormControl isRequired>
                            <FormLabel>Confirm New Password</FormLabel>
                            <Input 
                                type="password" 
                                value={confirmPassword} 
                                onChange={(e) => setConfirmPassword(e.target.value)}
                                placeholder="Confirm new password"
                            />
                        </FormControl>
                    </VStack>
                </ModalBody>
                <ModalFooter>
                    <Button variant="ghost" mr={3} onClick={onClose}>Cancel</Button>
                    <Button colorScheme="teal" onClick={handleSubmit} isLoading={loading}>
                        Update Password
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};

export default AdminChangePasswordModal;
